import { render, staticRenderFns } from "./organization-ddo-roadmap-view.vue?vue&type=template&id=3316f5c2&scoped=true"
import script from "./organization-ddo-roadmap-view.vue?vue&type=script&lang=js"
export * from "./organization-ddo-roadmap-view.vue?vue&type=script&lang=js"
import style0 from "./organization-ddo-roadmap-view.vue?vue&type=style&index=0&id=3316f5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3316f5c2",
  null
  
)

export default component.exports